import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http'
import { Constant } from '../../environments/constants';
import { Utils } from '../../utils/utils';
import { DataService } from './context/data.service';
import { AccountsService } from './accounts.service';
import { ExternalAccountService } from './external-account.service';
import { ContextService } from './context/context.service';
import { AppMonitoringService } from '../services/util/app-monitoring.service';
import * as fromModel from '../services/models/';

@Injectable({
  providedIn: 'root'
})
export class ClientsService {

  constructor(private http: HttpClient,
    // private dataService:DataService,
    private contextService: ContextService,
    private accountsService: AccountsService,
    private externalAccountService: ExternalAccountService,
    private appMonitoringService: AppMonitoringService) { }


  getClientAPI(clientIds) {
    let url =    Constant.uri.cosmosclientsearchapi + "?queryType=full&select=LegalEntityID,LegalEntityName,dateofBirth,loginDetails,investors,Account,externalAccounts,ClientKPI,dateofBirth,contactdetails,legalEntityType,householdId,householdName,householdList&$orderby=ClientKPI/AumTotal desc&$filter=((search.in(LegalEntityID,'" + clientIds +"')))";
    return this.http.get(encodeURI(url), Utils.getHttpOptions());
  }  

  // getClients(clientIds, dataService: DataService) {
  //   if(!dataService.appData.Clients || dataService.appData.Clients['Error']) {
  //     this.getClientAPI(clientIds).subscribe(result=>{
  //         dataService.dispatchAction(fromModel.DATA_ACTION.CLIENTS,"ClientsService-getClients", result);
  //     }, err=>{
  //       dataService.dispatchAction(fromModel.DATA_ACTION.CLIENTS,"ClientsService-getClients", {Error: fromModel.ERRORCODE.APIERROR, ErrorDetails: JSON.stringify(err)});
  //       console.log("Error getting Client Details: " + JSON.stringify(err));      
  //       this.appMonitoringService.traceMsg("Error getting Client Details: ", JSON.stringify(err) , 'Error');
  //     });
  //   }
  // }

  getClientDetails(planClients: fromModel.PlanClient[], dataService: DataService){
    let allAccountIds = [];
    let householdIds = [];
    let hhClients = [];
    let hhClientIds = [];

    let planClientIds = [];
    
    planClients.forEach(pCl => {
      planClientIds.push(pCl.clientid);
    });

    //Step 1: Call Client Searh API to get Clinet's Internal Accounts (NFS, GFO), Aggrigated Accounts and HouseholdIds
    this.getClientAPI(planClientIds).subscribe(clients=>{
        clients['value'].forEach(cl => {
          cl.Account.forEach(acc => {
            allAccountIds.push(acc);  
          });              
          cl.externalAccounts.forEach(extAcc => {
            allAccountIds.push(extAcc.accountId);  
          });

          const plnCl = planClients.find(_plCl=>_plCl.clientid === cl.LegalEntityID);
          if(plnCl){
            if(plnCl.role === fromModel.CLIENTROLE.Primary || plnCl.role === fromModel.CLIENTROLE.Secondary){
              if(cl.householdList && cl.householdList.length>0){
                (<[]>cl.householdList).forEach(household => {
                  householdIds.push(household['householdId']);
                });      
              }
            }
          }          
      });

      //Step 2: Call Household Searh API to get list of all associated clinets based on households from Step1
      this.getHouseHoldsByHouseholdIds(householdIds).subscribe(households => { 
        (<[]>households['value']).forEach(hh => {
          if(hh && hh['Parties'])
          {
            (<[]>hh['Parties']).forEach(cl => {
              hhClients.push({LegalEntityID: cl['LegalEntityId'], LegalEntityName: cl['LegalEntityName']});
              hhClientIds.push(cl['LegalEntityId']);
            });
          }        
        });

        //Step 3: Call again Client Searh API to get all Clinet's details and add in local data cache
        this.getClientAPI(hhClientIds).subscribe(clients=>{
          // clients['value'].forEach(cl => {
          //   cl.Account.forEach(acc => {
          //     allAccountIds.push(acc);  
          //   });              
          //   cl.externalAccounts.forEach(extAcc => {
          //     allAccountIds.push(extAcc.accountId);  
          //   });  
          // });  
          this.contextService.dispatchAction(fromModel.APP_ACTION.ACCOUNT, "ClientsService-getClientDetails",allAccountIds);                   
          dataService.dispatchAction(fromModel.DATA_ACTION.CLIENTS,"ClientsService-getClientDetails", {Clients:clients, Households: households});
          this.accountsService.getAccounts(allAccountIds, dataService);
          this.externalAccountService.getExternalAccountListByClientIds(planClientIds, dataService);
        }, err=>{  
          dataService.dispatchAction(fromModel.DATA_ACTION.CLIENTS,"ClientsService-getClientDetails", {Error: fromModel.ERRORCODE.APIERROR, ErrorDetails: JSON.stringify(err)});
          console.log("Error getting Client Details: " + JSON.stringify(err));      
          this.appMonitoringService.traceMsg("Error getting Client Details: ", JSON.stringify(err) , 'Error');            
        });


      }, err=>{
        console.log("Error getting Household clients - getClientDetails - Error :" + JSON.stringify(err));
      });

      // this.contextService.dispatchAction(fromModel.APP_ACTION.ACCOUNT, "ClientsService-getClientDetails",allAccountIds);                   
      // dataService.dispatchAction(fromModel.DATA_ACTION.CLIENTS,"ClientsService-getClientDetails", clients);
      // this.accountsService.getAccounts(allAccountIds, dataService);
      // this.externalAccountService.getExternalAccountListByClientIds(clientIds, dataService);
    }, err=>{  
      dataService.dispatchAction(fromModel.DATA_ACTION.CLIENTS,"ClientsService-getClientDetails", {Error: fromModel.ERRORCODE.APIERROR, ErrorDetails: JSON.stringify(err)});
      console.log("Error getting Client Details: " + JSON.stringify(err));      
      this.appMonitoringService.traceMsg("Error getting Client Details: ", JSON.stringify(err) , 'Error');            
    });
  }


  getHouseHoldsByHouseholdIds(householdIds) { 
    let url =    Constant.uri.cosmoshouseholdsearchapi + "?queryType=full&select=id,householdId,householdName,Parties,Account,householdKPI&$filter=((search.in(householdId,'" + [householdIds] +"')))";
    return this.http.get(encodeURI(url), Utils.getHttpOptions());
  }

  // getClients(clients) { 
  //   let url =    Constant.uri.cosmosclientsearchapi + "?queryType=full&select=LegalEntityID,LegalEntityName,dateofBirth,loginDetails,investors,Account,externalAccounts,ClientKPI,dateofBirth,contactdetails&$orderby=ClientKPI/AumTotal desc&$filter=((search.in(LegalEntityID,'" + clients +"')))";
  //   return this.http.get(encodeURI(url), Utils.getHttpOptions());
  // }

  removeClient(planId, clientid){
    console.log(`Enter: ClientsService - remove Client Id ${clientid} from Plan Id" + ${planId}`);
    console.log(`Exit: ClientsService - remove Client Id ${clientid} from Plan Id" + ${planId}`);
    return this.http.post<any>(Constant.uri.removeClient + planId + "/" + clientid, Utils.getHttpOptions());  
  }
}